export default __webpack_public_path__ + "static/media/main__hero__image.c5865caf.png";